/* RBF Back To Top — Horizon/current theme scroll-container compatible */
(function () {
  'use strict';

  function getTag() {
    return document.getElementById('rbf-tag');
  }

  function getScrollContainer() {
    if (window.matchMedia('(min-width: 990px)').matches) {
      return document.querySelector('.page-wrapper') || document.scrollingElement || document.documentElement;
    }
    return document.scrollingElement || document.documentElement;
  }

  function getScrollEventTarget() {
    if (window.matchMedia('(min-width: 990px)').matches) {
      return document.querySelector('.page-wrapper') || document;
    }
    return document;
  }

  function initBackToTop() {
    var el = getTag();
    if (!el || el.dataset.rbfInitialized === 'true') return;
    el.dataset.rbfInitialized = 'true';

    var threshold = parseInt(el.getAttribute('data-threshold') || '200', 10);
    var animate = el.getAttribute('data-animate');
    if (animate !== 'false') el.classList.add('rbf-animate');

    function getScrollTop() {
      var container = getScrollContainer();
      return Number(container && container.scrollTop) || 0;
    }

    function updateVisibility() {
      el.classList.toggle('is-visible', getScrollTop() > threshold);
    }

    function scrollToTop(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      var container = getScrollContainer();
      if (!container) return;

      try {
        container.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      } catch (_) {
        container.scrollTop = 0;
      }
    }

    function readVar(name, fallback) {
      var value = getComputedStyle(el).getPropertyValue(name).trim();
      var number = parseFloat(value);
      return Number.isNaN(number) ? fallback : number;
    }

    var jetHit = document.createElement('span');
    jetHit.className = 'rbf-jet-hit';
    jetHit.setAttribute('aria-label', 'Back to top');
    jetHit.setAttribute('role', 'button');
    jetHit.setAttribute('tabindex', '0');
    Object.assign(jetHit.style, {
      position: 'absolute',
      background: 'transparent',
      pointerEvents: 'auto',
      cursor: 'pointer',
      zIndex: '5',
      outline: 'none'
    });
    el.appendChild(jetHit);

    function positionJetHit() {
      var grommetTop = readVar('--rbf-grommet-top', 7);
      var ropeLen = readVar('--rbf-rope-len', 40);
      var jetGap = readVar('--rbf-jet-gap', 9);
      var jetSize = readVar('--rbf-jet-size', 40);
      var pad = 8;

      jetHit.style.top = (grommetTop - ropeLen - jetGap) + 'px';
      jetHit.style.left = '50%';
      jetHit.style.transform = 'translate(-50%, -50%)';
      jetHit.style.width = (jetSize + pad) + 'px';
      jetHit.style.height = (jetSize + pad) + 'px';
    }

    function onKeydown(event) {
      if (event.key === 'Enter' || event.key === ' ') scrollToTop(event);
    }

    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.addEventListener('click', scrollToTop);
    el.addEventListener('keydown', onKeydown);
    jetHit.addEventListener('click', scrollToTop);
    jetHit.addEventListener('keydown', onKeydown);

    var currentTarget = null;
    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        updateVisibility();
        ticking = false;
      });
    }

    function bindScrollTarget() {
      var nextTarget = getScrollEventTarget();
      if (currentTarget === nextTarget) return;
      if (currentTarget) currentTarget.removeEventListener('scroll', onScroll);
      currentTarget = nextTarget;
      currentTarget.addEventListener('scroll', onScroll, { passive: true });
    }

    function refresh() {
      bindScrollTarget();
      positionJetHit();
      updateVisibility();
    }

    window.addEventListener('resize', refresh, { passive: true });
    window.addEventListener('pageshow', refresh);

    refresh();
    requestAnimationFrame(refresh);
    setTimeout(refresh, 250);
  }

  function boot() {
    initBackToTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    var el = getTag();
    if (el) delete el.dataset.rbfInitialized;
    initBackToTop();
  });
})();
